<h4 mat-dialog-title class="dialog-title">
    <mat-icon class="warning-icon">warning</mat-icon>
    {{ data.title }}
</h4>
<mat-dialog-content>
    <p class="description">{{ data.description }}</p>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button (click)="onNoClick()">Cancel</button>
    <button mat-raised-button color="primary" [mat-dialog-close]="true" cdkFocusInitial>
        Yes
    </button>
</mat-dialog-actions>